import React from 'react';
import './MeasurementForm.css';

interface BrandInputProps {
  value: string | null;
  onChange: (value: string | null) => void;
  disabled?: boolean;
}

const BrandInput: React.FC<BrandInputProps> = ({
  value,
  onChange,
  disabled = false
}) => {
  return (
    <div className="form-group">
      <label htmlFor="brand">Brand</label>
      <input
        type="text"
        id="brand"
        value={value || ''}
        onChange={(e) => onChange(e.target.value || null)}
        placeholder="Enter brand name"
        disabled={disabled}
      />
    </div>
  );
};

export default BrandInput;
